import PhotoSwipeLightbox from 'photoswipe/lightbox';

export default class PhotoGallery {
    constructor() {
        this.applyEvents();
    }

    applyEvents() {
        this.initializeGalleries();
    }

    initializeGalleries() {
        const lightbox = new PhotoSwipeLightbox({
            gallery: '.category__gallery',
            children: 'a',
            showHideAnimationType: 'none',
            zoomAnimationDuration: false,
            pswpModule: () => import('photoswipe')
        });
        lightbox.init();
    }
}